// src/utils/idEncoder.ts
import Hashids from 'hashids';

// 1. "MySecretSalt123" -> Change this to a random unique string
// 2. 10 -> The minimum length of the generated ID
const hashids = new Hashids("WorkHorseSecureSalt2024", 10); 

export const encodeId = (id: number | string): string => {
  const numericId = typeof id === 'string' ? parseInt(id, 10) : id;
  if (isNaN(numericId)) return '';
  return hashids.encode(numericId);
};

export const decodeId = (hash: string): number | null => {
  const decoded = hashids.decode(hash);
  // Returns number or null if invalid
  return decoded.length > 0 ? (decoded[0] as number) : null;
};